// extracted by mini-css-extract-plugin
export default {"container":"Certifications_container__TX+6C","header":"Certifications_header__Hhpi4","content":"Certifications_content__hHM1Z","imgMobil":"Certifications_imgMobil__-Cof7"};